/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"

import Footer from "./footer"
import "@fontsource/open-sans"
import "@fontsource/open-sans/600.css"
import "@fontsource/open-sans/700.css"
import "@fontsource/open-sans/800.css"
import '../style/common.css';


import googleOneTap from 'google-one-tap'
import { Helmet } from "react-helmet"
import axios from "axios"
import Header from "./header"
// import {AmplitudeProvider, Amplitude} from "@amplitude/react-amplitude"
// import amplitude from "amplitude-js"
import Cookies from "js-cookie"
// import amplitudeClient from "../utils/amplitude-track"


const options={
  client_id: '401093927699-jgqudtu0s7daufo141j1emat49ug7aqh.apps.googleusercontent.com', 
	cancel_on_tap_outside: false
}

let buildApi=`${process.env.REACT_APP_CONFIG_BASEURL}`
let buildDomain=`${process.env.REACT_APP_CONFIG_APPDOMAIN}`

const Layout = ({ children }) => {
  const [refreshFlag,setRefreshFlag]=React.useState(0)

  React.useEffect(()=>{

    let body = document.getElementsByTagName("body")[0]

    googleOneTap(options, (e) => {
      // window.sa && window.sa.Track("login", {type: 'google'});
      // amplitudeClient.logEvent('[Web]login', {pathname: window.location.pathname, type: 'google'})
      axios.post(buildApi + '/generate-auth-token-google', { idToken: e.credential, sourcePage: window.location.pathname }, {
        validateStatus: function(status) {
            switch (status) {
                case 401:
                    alert('Wrong username or password!');
                    break;
                case 400:
                    alert('Submission failed!');
                    break;
                default:
                    return status >= 200 && status < 300;
            }
        }
      }).then(function(response) {
        let w = document.createElement('aside');
        Cookies.set('cocofaxToken', response.data.token, { path: '/', domain: 'cocofax.com', expires: 30})
        Cookies.set('cocofaxName', response.data.email, { path: '/', domain: 'cocofax.com', expires: 30})
        if (response.data.isNewUser) {
            w.className = "googleCredentialPopu";
            w.innerHTML = '<div class="close-btn"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#5f6368" width="24" height="24" style=""><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg></div><div class="wrap"><p class="info">You account has been successfully registered at CocoFax! You may view your password at <span class="text-green">' + response.data.email + '</span>.</p><div class="group-btn flex justify-between"><a href="mailto:' + response.data.email + '" class="check-btn btn white-btn">Check My Email</a> <a href="https://app.cocofax.com/page/newfax" class="send-btn btn green-btn">Send Fax Now</a></div></div>';
            body.appendChild(w);
            document.querySelector(".googleCredentialPopu .close-btn").addEventListener("click", function() {
                document.querySelector(".googleCredentialPopu").classList.add("hidden");
            })
        } else {
            window.location.href = buildDomain;
        }
        setRefreshFlag(refreshFlag+1)
      }).catch(function(error) {
          console.log(error);
      });
    });

  },[])

  

  return (
    <>
      <Helmet>
        <script type="text/javascript" id="pap_x2s6df8d" src="https://cocofax.postaffiliatepro.com/scripts/nd3wj0aq2"></script>
        <script type="text/javascript" defer>
          {`
            document.addEventListener('DOMContentLoaded',function(){
              window.PostAffTracker.setAccountId('default1');window.PostAffTracker.track();
            })
          `}
        </script>
        <script type="text/javascript" defer>
          {`
            (function (c, p, d, u, id, i) {
              id = ''; // Optional Custom ID for user in your system
              u = 'https://tracking.g2crowd.com/attribution_tracking/conversions/' + c + '.js?p=' + encodeURI(p) + '&e=' + id;
              i = document.createElement('script');
              i.type = 'application/javascript';
              i.async = true;
              i.src = u;
              d.getElementsByTagName('head')[0].appendChild(i);
            }("5345", document.location.href, document));
          `}
        </script>
      </Helmet>
      <Header refreshFlag={refreshFlag}/>
      <main className="overflow-hidden relative bg-gray-lightest">{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
